// src/api.ts
import axios from "axios";
import { Project } from "types";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL ||"/",
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

export const webApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL ||"/",
  withCredentials: true,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift();
}

webApi.interceptors.request.use((config) => {
  const xsrfToken = getCookie("XSRF-TOKEN");
  if (xsrfToken) {
    config.headers["X-XSRF-TOKEN"] = decodeURIComponent(xsrfToken);
  }
  return config;
});

export const getCsrfToken = async () => {
  try {
    await webApi.get("/sanctum/csrf-cookie");
  } catch (error) {
    console.error("Error fetching CSRF token:", error);
  }
};

export const getAnnouncements = (params?: any) =>
  api.get("/announcements", { params });

export const getEvents = (params?: any) => api.get("/events", { params });

export const getProjects = (params?: any) => api.get("/projects", { params });

export const getProject = (id: number) => api.get<Project>(`/projects/${id}`);

export const createContactInquiry = (data: any) => api.post("/contact", data);

export const getStats = () => api.get("/stats");

export default api;
